




import { EVENTS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class BackgroundClose extends Vue {
  onClick() {
    this.$x.emit(EVENTS.CloseEmpathyX);
  }
}
